// IA What's Included — drives the bundle-card scroller: prev/next arrows
// (desktop slider mode), mobile dots synced to scroll position, and the theme
// editor's block-select. The sliding itself is native CSS scroll-snap, so this
// element only reads/scrolls the track — it never creates DOM.

if (!customElements.get('ia-whats-included')) {
  class IaWhatsIncluded extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-wi-track]');
      if (!this.track) return;

      this.cards = Array.from(this.track.querySelectorAll('[data-wi-card]'));
      this.dots = Array.from(this.querySelectorAll('[data-wi-dot]'));
      this.prevButton = this.querySelector('[data-wi-prev]');
      this.nextButton = this.querySelector('[data-wi-next]');

      this.onScroll = this.onScroll.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.scrollToIndex(i)));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      this.sync();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      cancelAnimationFrame(this.raf);
    }

    onScroll() {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.sync());
    }

    // Card whose left edge sits nearest the track's left edge.
    activeIndex() {
      const trackLeft = this.track.getBoundingClientRect().left;
      let best = 0;
      let min = Infinity;
      this.cards.forEach((card, i) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < min) {
          min = distance;
          best = i;
        }
      });
      return best;
    }

    sync() {
      const index = this.activeIndex();
      this.dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });

      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      this.prevButton?.classList.toggle('ia-visibility-hidden', this.track.scrollLeft <= 0);
      this.nextButton?.classList.toggle('ia-visibility-hidden', this.track.scrollLeft >= maxScroll);
    }

    step(direction) {
      this.scrollToIndex(this.activeIndex() + direction);
    }

    scrollToIndex(index) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      card.scrollIntoView({
        behavior: reduce ? 'auto' : 'smooth',
        inline: 'start',
        block: 'nearest',
      });
    }

    // Theme editor: bring the selected card into view.
    handleBlockSelect(event) {
      const card = event.target.closest?.('[data-wi-card]');
      if (!card || !this.contains(card)) return;
      const index = this.cards.indexOf(card);
      if (index >= 0) this.scrollToIndex(index);
    }
  }

  customElements.define('ia-whats-included', IaWhatsIncluded);
}
